import { Client, ClientScoringRuleState } from "./types";

// The API stores disabled clients, so a client is enabled when it is absent from that list.
export const getInitiallyEnabledClientIds = (
  clients: Client[],
  ignoredClientIds: number[],
): Set<number> => {
  const ignored = new Set(ignoredClientIds);
  return new Set(
    clients
      .map((client) => client.clientInformation.id)
      .filter((id) => !ignored.has(id)),
  );
};

// Only changed clients are sent so a save never rewrites rows the user did not touch.
export const getChangedClientStates = (
  clients: Client[],
  initiallyEnabled: Set<number>,
  enabled: Set<number>,
): ClientScoringRuleState[] =>
  clients
    .map((client) => client.clientInformation.id)
    .filter((id) => initiallyEnabled.has(id) !== enabled.has(id))
    .map((id) => ({ clientId: id, enabled: enabled.has(id) }));

export const filterClientsByName = (
  clients: Client[],
  search: string,
): Client[] => {
  const term = search.trim().toLowerCase();
  if (!term) return clients;
  return clients.filter((client) =>
    client.clientInformation.name.toLowerCase().includes(term),
  );
};
